import config from "../config"

const __symbolPrefix = '3r/create-react-chi-module-template/'

const Constants = {
    __symbolPrefix
}
export default Constants;
